/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SendInvitationRequestDto model module.
 * @module model/SendInvitationRequestDto
 * @version v0
 */
class SendInvitationRequestDto {
    /**
     * Constructs a new <code>SendInvitationRequestDto</code>.
     * @alias module:model/SendInvitationRequestDto
     * @param invitedEmail {String} Email del usuario a invitar
     */
    constructor(invitedEmail) { 
        
        SendInvitationRequestDto.initialize(this, invitedEmail);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, invitedEmail) { 
        obj['invitedEmail'] = invitedEmail;
    }

    /**
     * Constructs a <code>SendInvitationRequestDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SendInvitationRequestDto} obj Optional instance to populate.
     * @return {module:model/SendInvitationRequestDto} The populated <code>SendInvitationRequestDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SendInvitationRequestDto();

            if (data.hasOwnProperty('invitedEmail')) {
                obj['invitedEmail'] = ApiClient.convertToType(data['invitedEmail'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SendInvitationRequestDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SendInvitationRequestDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SendInvitationRequestDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['invitedEmail'] && !(typeof data['invitedEmail'] === 'string' || data['invitedEmail'] instanceof String)) {
            throw new Error("Expected the field `invitedEmail` to be a primitive type in the JSON string but got " + data['invitedEmail']);
        }

        return true;
    }


}

SendInvitationRequestDto.RequiredProperties = ["invitedEmail"];

/**
 * Email del usuario a invitar
 * @member {String} invitedEmail
 */
SendInvitationRequestDto.prototype['invitedEmail'] = undefined;






export default SendInvitationRequestDto;

